import { __awaiter, __generator } from "tslib";
import axios from 'axios';
import useSWRImmutable from 'swr/immutable';
var fetcher = function (url) {
    return axios
        .get(url)
        .then(function (res) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, res.data];
    }); }); });
};
export var useFetchCPV = function (url) {
    var _a = useSWRImmutable(url, fetcher, {
        suspense: true,
    }), data = _a.data, error = _a.error, mutate = _a.mutate;
    return {
        setState: mutate,
        cpvCodes: data,
        isLoadingCPV: !error && !data,
        isErrorFetchingCPV: error,
    };
};
